<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-bind="attrs"
    src="https://nexthealth.es/wp-content/uploads/2025/11/Log_NH_IFNTY-removebg-preview.png"
    alt="NextHealth Logo"
  />
</template>
